<template>
  <div>
    <NetworkIdentification
      :readonly="true"
      :networkIdentification="datas.networkIdentification"
    />
    <OperatingConditions
      :readonly="true"
      :operatingConditions="datas.operatingConditions"
    />
    <Filtration
      :readonly="true"
      :filtration="datas.filtration"
    />
  </div>
</template>

<script>

import NetworkIdentification from '@/components/forms/technicalFile/cooling/forms/NetworkIdentification.vue';
import OperatingConditions from '@/components/forms/technicalFile/cooling/forms/OperatingConditions.vue';
import Filtration from '@/components/forms/technicalFile/cooling/forms/Filtration.vue';

export default {
    name: 'TechnicalFileCooling',
    components: { NetworkIdentification, OperatingConditions, Filtration },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            datas: { },
        };
    },

    async mounted() {
        if (this.mutableValue) {
            const myDatas = await this.initDataFromBackend();
            this.datas = myDatas.data;
        }
    },
    methods: {
        async initDataFromBackend() {
            const { data } = await this.$rq.getNodeInfo(this.mutableValue.analysisRequest.site.id, this.mutableValue.analysisRequest.component.id);
            return {
                data,
            };
        },
    },
};

</script>
